
<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="750px">
        <v-card height="350px">          
          <v-form v-model="dailyReportForm">
            <v-card-title>
                <v-btn icon absolute top right color="dark" @click.prevent="closeDialog">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-row>
                    <v-col cols="6" class="text-left">
                        <strong v-if="!is_adding">{{dailyReport.user ? dailyReport.user.full_name : '-'}}</strong>
                        <v-autocomplete
                        v-if="is_adding"
                        dense
                        outlined
                        v-model="dailyReport.user"
                        :items="staff"
                        item-text="full_name"
                        label="Select Staff"
                        class="rounded-input"
                        return-object
                        :rules="[rules.required, rules.requiredObject]"
                        hide-details="auto"></v-autocomplete>
                    </v-col>
                    <v-col cols="5" class="text-right">
                        <strong v-if="!is_editing && !is_adding">{{moment(dailyReport.date).format('D MMM, YYYY')}}</strong>
                          <v-menu
                            v-if="is_editing || is_adding"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date" 
                            transition="scale-transition"
                            offset-y
                            ref="reportDate"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                append-icon="fas fa-calendar"
                                readonly
                                outlined
                                dense
                                label="Report Date"
                                placeholder="01-01-2000"
                                :value="formattedDate(dailyReport.date)"                           
                                :rules="[rules.required]"
                                class="rounded-input"
                                v-bind="attrs"
                                v-on="on"
                                hide-details="auto"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              :max="new Date().toISOString().substr(0, 10)"
                              min="1950-01-01"
                              v-model="dailyReport.date"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.reportDate.save(date)">OK</v-btn>
                            </v-date-picker>
                          </v-menu>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-2">
                    <!-- <v-container> -->
                        <div class="quill-editor">
                            <quill :content="dailyReport.report"
                            class="editor"
                            v-if="is_editing || is_adding"
                            :options="editorOption"
                            @change="onEditorChange($event)">
                            </quill>
                        </div>
                        <div v-html="dailyReport.report" style="height: 13rem;max-width:100%;" class="ql-editor" v-if="!is_editing && !is_adding">
                        </div>
                          <v-row class="justify-center pt-2 mx-2 py-4" v-if="!is_editing && !is_adding" justify="center">
                            <v-col cols="6" v-if="currentUser.id==dailyReport.user.id || currentUser.privileges.canEditAllDailyReports">
                                <v-btn block color="indigo" class="pl-1 white--text" @click="editDailyReports">
                                    <v-icon color="white" class="px-2">
                                        mdi-clipboard-edit-outline
                                    </v-icon>
                                    Edit
                                </v-btn>
                            </v-col>
                            <v-col cols="6" v-if="currentUser.id==dailyReport.user.id || currentUser.privileges.canDeleteAllDailyReports">
                                <v-btn block color="red" class="pl-1 white--text" @click="deleteDailyReport">
                                    <v-icon color="white" class="px-2"> mdi-delete </v-icon>
                                    Delete
                                </v-btn>
                            </v-col>
                        </v-row>
                        
                        <v-row v-if="is_editing || is_adding" class="pt-2" justify="center">
                            <!-- <v-col cols="6" md="3">
                                <v-btn color="red" class="pl-1 white--text" @click.prevent="closeDialog">
                                    <v-icon color="white" class="px-2">mdi-close</v-icon>
                                    Cancel
                                </v-btn>
                            </v-col> -->
                            <v-col cols="6" md="3">
                                <v-btn color="green" class="pl-1 white--text" @click="createDailyReport" :disabled="!dailyReportForm">
                                    <v-icon color="white" class="px-2">mdi-content-save-all</v-icon>
                                    Save
                                </v-btn>
                            </v-col>
                        </v-row>
                    <!-- </v-container> -->                               
            </v-card-text>
            </v-form> 
        </v-card>
      </v-dialog>
    </v-row>

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.visible = false"
          >Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import moment from "moment";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
// import Helper from "@utils/misc";
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: "AddEditDailyReport",
  components: {quill:quillEditor},
  props: {
    is_adding: {
      type: Boolean,
      default() {
        return false;
      }
    },
    is_editing: {
      type: Boolean,
      default() {
        return false;
      }
    },
    id: {
      type: Number,
      default() {
        return null;
      }
    },
    dialog: {
      type: Boolean,
      default() {
        return false;
      }
    },
    staff: {
      type: Array,
      default() {
        return null;
      }
    },
//     record_id: {
//       type: Number,
//       default() {
//         return null;
//       }
//     },
//     type: {
//       type: String,
//       default() {
//         return null;
//       }
//     },
    viewOnlyMode: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },

  computed: {
    ...mapGetters([
      "currentUser",
      "accessToken",
      "isLoading",
      "currentInstitution"
    ]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors
      };
    }
  },

  data() {
    return {
      snackbar: {
        visible: false,
        message: "",
        color: "dark"
      },
      dailyReportForm: false,
      reportQuillobj:{delta: null, html: null},    
      editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              // ['blockquote', 'code-block'],
              // [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              // [{ 'script': 'sub' }, { 'script': 'super' }],
              // [{ 'indent': '-1' }, { 'indent': '+1' }],
              // [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              // [{ 'font': [] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              // ['clean'],
              ['link', 'image',]
            ],
          }
      },
      menu: false,
      date: null,
      dailyReport: {
        user: {},
      },      
      rules: {
        required: value => !!value || "Required",
        requiredObject: value => Object.keys(value).length > 0 || "Required",
      },
      submitForm: false,
      moment: moment,
      endpoints: endpoints,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    // handle api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        this.snackbar.message = "Unable to process request";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },

    editDailyReports() {
      this.is_editing = true;
    },

    deleteDailyReport() {
      this.$emit("deleteDailyReport", this.dailyReport.id);
    },
    
    onEditorChange({ quill, html, text }) {
        console.log('editor change!', quill, html, text)
        this.dailyReport.report = html
        this.reportQuillobj.delta = quill.editor.delta
        this.reportQuillobj.html = html
    },

    closeDialog() {
      this.$emit("closeDialog");
      this.is_editing = false;
      this.is_adding = false;
      this.dailyReport = {
        user: {},
        date: null
      };
      console.log("#", this.is_adding);
    },

    async handleClick(value) {
      if (!value) return;
      var url = endpoints.dailyReportsViewSet + `${value}/`;

      var response = await api.call(this.essentials, url);

      if (response) {
        this.dailyReport = response
        console.log(response)
      }
    },

    async createDailyReport() {
      var url = endpoints.dailyReportsViewSet;
      var response;
      if (this.is_adding) {
        let post_body = {
          user: this.dailyReport.user.id,
          date: this.dailyReport.date,
          reportQuillObj: this.reportQuillobj,
          report: null,
          creator: this.currentUser.id,
          institution: this.currentInstitution.id,
        }

        response = await api.call(
          this.essentials,
          url,
          api.Methods.POST,
          post_body
        );

        if (response) {
          console.log(response);
          console.log("Added");
          this.closeDialog();
          // this.snackbar.color = "dark";
          // this.snackbar.message = "Daily Report added successfully";
          // this.snackbar.visible = true;
        }
      } else if(this.is_editing) {
        url += `${this.dailyReport.id}/`;
        let post_body = {
          date: this.dailyReport.date,
          reportQuillObj: this.reportQuillobj,
          report: null,
          user: this.dailyReport.user.id,
          creator: this.currentUser.id,
          institution: this.currentInstitution.id,
        }

        response = await api.call(
          this.essentials,
          url,
          api.Methods.PUT,
          post_body
        );

        if (response) {
          console.log(response);
          console.log("Edited");
          this.closeDialog();
          this.snackbar.color = "dark";
          this.snackbar.message = "Daily Report edited successfully";
          this.snackbar.visible = true;
        }
      }
    },

    formattedDate(date) {
      if (!date) return;
      var formatted = moment(date).format('D MMM YYYY');
      return formatted;
    },

    deleteTransaction() {
      this.$emit("deleteTransaction", this.dialogValues.id);
      // this.closeDialog();
    },
  },

  async created() {
  },

  // watch: {

  //   id: {
  //     async handler() {
  //       if (this.id) this.handleClick(this.id);
  //     }
  //   },

  //   adding: {
  //     async handler() {
  //       this.is_adding = this.adding;
  //     }
  //   },

  //   editing: {
  //     async handler() {
  //       this.is_editing = this.editing;
  //     }
  //   },

  //   dialog: {
  //     async handler() {
  //       if (!this.dialog) this.closeDialog();
  //     }
  //   }
  // }
};
</script>

<style scoped>
.editor{
  height: 13rem;
  overflow: scroll
}
</style>